module.exports = __webpack_public_path__ + "img/document.fac8cbfe.svg";